var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-panel',{attrs:{"breadcrumbs":_vm.breadcrumbsItems,"title":_vm.$t('app.sidebar_items.indicators')}})}
var staticRenderFns = []

export { render, staticRenderFns }